<template>
<div class="consult-form">
  <div class="title">技术服务咨询</div>
  <div class="form-box">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
  >
    <a-form-model-item label="咨询主题" prop="consultTitle">
      <a-input v-model="form.consultTitle" placeholder="请输入咨询主题"/>
    </a-form-model-item>
    <a-form-model-item label="提交人" prop="contactPerson">
      <a-input
          v-model="form.contactPerson"
          placeholder="请输入提交人"
      />
    </a-form-model-item>
    <a-form-model-item label="联系电话" prop="contactPhone">
      <a-input
          v-model="form.contactPhone"
          placeholder="请输入联系电话"
          :max-length="11"
      />
    </a-form-model-item>
    <a-form-model-item label="验证码" prop="contactPhoneCode" v-if="!isLogin">
      <a-input
          v-model="form.contactPhoneCode"
          placeholder="请输入验证码"
      >
        <template slot="suffix">
          <v-count-down
              :trigger="() => sendMobileCode()"
              :phone="form.contactPhone"
          >
            <template #default>获取验证码</template>
            <template #loading="scope"
            >{{ scope.seconds }}秒后重新发送</template
            >
          </v-count-down>
        </template>
      </a-input>
    </a-form-model-item>
    <a-form-model-item label="所属单位" prop="contactCompany">
      <a-input
          v-model="form.contactCompany"
          placeholder="请输入所属单位"
      />
    </a-form-model-item>
    <a-form-model-item label="咨询详情" prop="consultDesc">
      <a-textarea
          v-model="form.consultDesc"
          placeholder="请输入咨询详情"
          :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </a-form-model-item>
      <a-form-model-item label="附件" prop="consultAttmId">
        <upload-files
            file-type-code="9999"
            :isShowList="true"
            @success="uploadChange"
            @uploadRemove="uploadRemove"
            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.rar,.zip"
            :maxNum="5"
            ref="uploadFiles"
        >
        </upload-files>

      </a-form-model-item>
      <p class="tip">支持上传doc/docx/xls/xlsx/ppt/pptx/pdf/rar/zip等文件，最多5个文件，且单个文件大小不超过20M</p>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
        <a-button class="btn-red" @click="onSubmit" :loading="loading">提交咨询</a-button>
      </a-form-model-item>
  </a-form-model>
  </div>
</div>
</template>

<script >
import VCountDown from '@/components/VCountDown.vue'
import {sendMobile} from '@/api/common.js'
import VMultiUpload from '@/components/VMultiUpload.vue'
import VUploadAvatar from '@/components/VUploadImgList.vue'
import {message} from 'ant-design-vue'
import {getConsultCreate} from '@/api/news.js'
import {mapGetters} from 'vuex'
import uploadFiles from '@/components/uploadFiles.vue'

export default{
  components: {uploadFiles, VUploadAvatar, VMultiUpload, VCountDown},
  data(){
    const validatorPhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确!"));
      } else {
        callback();
      }
    };
    return{
      loading:false,
      form:{
        annex: [],
      },
      rules:{
        consultTitle: [
          { required: true, message: "请输入咨询主题", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入提交人  ", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        contactPhoneCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(["isLogin","userInfo"]),
  },
  methods:{
    uploadChange(val) {
      this.form.annex.push(val.id);
    },
    uploadRemove(id) {
      console.log(id,'form.annexid--id')
      for (let index = 0; index < this.form.annex.length; index++) {
        const element = this.form.annex[index];
        if (element === id) {
          this.form.annex.splice(index, 1);
        }
      }
    },
    sendMobileCode() {
      if(!this.form.contactPhone){
        message.warn('请先输入手机号')
        return
      }
      const { contactPhone } = this.form;
      sendMobile(contactPhone).then(() => {
        this.$message.success("发送成功！");
      });
    },
    async onSubmit(){
      let { form } = this;
      await this.$refs.ruleForm.validate()
      this.loading=true
      let data = {
        consultSource: "鸿联云",
        consultTitle: form.consultTitle,
        consultContent: form.consultDesc,
        contactDetail: form.contactPhone,
        contactPerson: form.contactPerson,
        consultAttmId: form.annex,
        contactCompany: form.contactCompany,
      };
      await getConsultCreate(data)
      this.$message.success("提交成功！")
      this.$refs.ruleForm.resetFields();
      this.loading=false
    },
  },
  mounted() {
    if (this.isLogin) {
      console.log(this.userInfo)
      const {userInfo}=this
      let obj={
        contactPerson:userInfo.realName,
        contactPhone:userInfo.phone,
      }
      if(userInfo.companyNames){
        obj.contactCompany=userInfo.companyNames[0]
      }
      this.form=Object.assign({},this.form,obj)
    }
  }
}
</script>


<style scoped lang="scss">
.consult-form{
  width: 376px;
  background: #FFFFFF;
  .title{
    font-weight: 600;
    font-size: 16px;
    color: #262626;
    line-height: 24px;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
  .form-box{
    padding: 24px 0;
    .tip{
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
      padding: 24px;
    }
    .btn-red{
      width: 136px;
      height: 40px;
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 25px;
    }
    ::v-deep .ant-form{
      >.ant-form-item{
        display: flex;
        .ant-form-item-label{
          width: 114px;
        }
        .ant-form-item-control-wrapper{
          width: 238px;
        }
      }
    }
  }
}
</style>
